<template>
    <div>
        <loading :active.sync=" isLoading " :is-full-page=" true "></loading>
        <b-card
            header="<h3><i class='fa fa-pencil-square-o'></i> <strong>Form</strong> Pembawaan Barang Asal TLDDP</h3>">
                <div class="row">
                    <!-- Data Pemberitahu -->
                    <div class="col-md-6">
                        <b-card header="<i class='fa fa-user'></i> Data Pemberitahu">
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nama Lengkap">
                                        <input v-model="headerTransit.namaPemberitahu" type="text" class="form-control" name="Nama Pemberitahu"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Nama Pemberitahu')">{{
                                                errors.first('Nama Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <b-form-fieldset label="Jenis Identitas">
                                        <select v-model="headerTransit.jenisIdPemberitahu" name="Jenis Identitas Pemberitahu" id="" class="form-control" v-validate="'required'">
                                            <option value="NPWP">NPWP</option>
                                            <option value="KTP">KTP</option>
                                            <option value="Paspor">Paspor</option>
                                            <option value="Lainnya">Lainnya</option>
                                        </select>
                                        <small class="text-danger" v-show="errors.has('Jenis Identitas Pemberitahu')">{{errors.first('Jenis Identitas Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                                <div class="col-md-8">
                                    <b-form-fieldset label="Nomor Identitas">
                                        <input v-model="headerTransit.idPemberitahu" type="text" class="form-control" name="Nomor Identitas Pemberitahu"
                                            v-validate="headerTransit.jenisIdPemberitahu === 'NPWP' ? 'required|min:16' : 'required'">
                                        <small class="text-danger" v-show="errors.has('Nomor Identitas Pemberitahu')">{{
                                                errors.first('Nomor Identitas Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Alamat">
                                        <input v-model="headerTransit.alamatPemberitahu" type="text" class="form-control" name="Alamat Pemberitahu"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Alamat Pemberitahu')">{{
                                                errors.first('Alamat Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Pekerjaan">
                                        <input v-model="headerTransit.pekerjaanPemberitahu" type="text" class="form-control" name="Pekerjaan Pemberitahu"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Pekerjaan Pemberitahu')">{{
                                                errors.first('Pekerjaan Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nomor Telepon">
                                        <input v-model="headerTransit.noTelpPemberitahu" type="text" class="form-control" name="Nomor Telepon Pemberitahu"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Nomor Telepon Pemberitahu')">{{
                                                errors.first('Nomor Telepon Pemberitahu') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                        </b-card>
                    </div>
                    <!-- DATA SPONSOR -->
                    <div class="col-md-6">
                        <b-card header="<i class='fa fa-user'></i> Data Sponsor">
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nama Lengkap">
                                        <input v-model="headerTransit.namaSponsor" type="text" class="form-control" name="Nama Sponsor">
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <b-form-fieldset label="Jenis Identitas">
                                        <select v-model="headerTransit.jenisIdSponsor" name="Jenis Identitas Sponsor" id="" class="form-control">
                                            <option value="NPWP">NPWP</option>
                                            <option value="KTP">KTP</option>
                                            <option value="Paspor">Paspor</option>
                                            <option value="Lainnya">Lainnya</option>
                                        </select>
                                    </b-form-fieldset>
                                </div>
                                <div class="col-md-8">
                                    <b-form-fieldset label="Nomor Identitas">
                                        <input v-model="headerTransit.idSponsor" type="text" class="form-control" name="Nomor Identitas Sponsor" v-validate="headerTransit.jenisIdSponsor === 'NPWP' ? 'min:16' : ''">
                                        <small class="text-danger" v-show="errors.has('Nomor Identitas Sponsor')">{{
                                                errors.first('Nomor Identitas Sponsor') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Alamat">
                                        <input v-model="headerTransit.alamatSponsor" type="text" class="form-control" name="Alamat Sponsor">
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Pekerjaan">
                                        <input v-model="headerTransit.pekerjaanSponsor" type="text" class="form-control" name="Pekerjaan Sponsor">
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nomor Telepon">
                                        <input v-model="headerTransit.noTelpSponsor" type="text" class="form-control" name="Nomor Telepon Sponsor">
                                    </b-form-fieldset>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
                <div class="row">
                    <!-- Data Penggunaan Barang -->
                    <div class="col-md-6">
                        <b-card header="<i class='fa fa-archive'></i> Data Penggunaan Barang">
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Jenis Pemasukan">
                                        <select name="Jenis Pemasukan" id="" class="form-control" v-model="headerTransit.jenisPemasukan" v-validate="'required'">
                                            <option value=""></option>
                                            <option value="Barang Bawaan Penumpang">Melalui Kawasan Bebas</option>
                                            <option value="Barang Awak Sarana Pengangkut">Sementara</option>
                                        </select>
                                        <!-- <input v-model="headerTransit.jenisPemasukan" type="text" class="form-control" name="Jenis Pemasukan" v-validate="'required'"> -->
                                        <small class="text-danger" v-show="errors.has('Jenis Pemasukan')">{{
                                                errors.first('Jenis Pemasukan') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Tujuan Pemasukan">
                                        <!-- <input v-model="headerTransit.tujuanPemasukan" type="text" class="form-control" name="Tujuan Pemasukan" v-validate="'required'"> -->
                                         <select name="Tujuan Pemasukan" id="" v-model="headerTransit.tujuanPemasukan" class="form-control" v-validate="'required'">
                                            <option value=""></option>
                                            <option value="Transit">Transit</option>
                                            <option value="Perbaikan/rekondisi/pengujian/kalibrasi">Perbaikan/rekondisi/pengujian/kalibrasi</option>
                                            <option value="Sewa menyewa">Sewa menyewa</option>
                                            <option value="Pameran/peragaan/demonstrasi">Pameran/peragaan/demonstrasi</option>
                                            <option value="Pertunjukan umum/olah raga/perlombaan">Pertunjukan umum/olah raga/perlombaan</option>
                                            <option value="Keperluan contoh/model">Keperluan contoh/model</option>
                                            <option value="Keperluan profesional/tenaga ahli">Keperluan profesional/tenaga ahli</option>
                                            <option value="Lainnya">Lainnya</option>
                                         </select>
                                        <small class="text-danger" v-show="errors.has('Tujuan Pemasukan')">{{
                                                errors.first('Tujuan Pemasukan') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row" v-if="headerTransit.tujuanPemasukan == 'Lainnya'">
                                <div class="col">
                                    <b-form-fieldset label="Tujuan Pemasukan Lainnya">
                                        <input type="text" class="form-control" v-model="headerTransit.tujuanPemasukanLainnya">
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Lokasi Penggunaan">
                                        <input v-model="headerTransit.lokasiPenggunaan" type="text" class="form-control" name="Lokasi Penggunaan"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Lokasi Penggunaan')">{{
                                                errors.first('Lokasi Penggunaan') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Asal Barang">
                                        <!-- <select name="Asal Barang" id="" class="form-control" v-model="headerTransit.asalBarang" v-validate="'required'">
                                            <option value=""></option>
                                            <option value="LDP">Luar Daerah Pabean / Luar Negeri</option>
                                            <option value="TLLDP">Tempat Lain Dalam Daerah Pabean / Dalam Negeri Lainnya</option>
                                            <option value="KB Lain">Kawasan Berikat atau Kawasan Bebas Lain</option>
                                        </select> -->
                                        <input v-model="headerTransit.asalBarang" type="text" class="form-control" name="Asal Barang" v-validate="'required'" placeholder="Contoh: Surabaya">
                                        <small class="text-danger" v-show="errors.has('Asal Barang')">{{
                                                errors.first('Asal Barang') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Perkiraan Tanggal Keluar">
                                        <input v-model="headerTransit.perkiraanTanggalKeluar" type="date" class="form-control" name="Perkiraan Tanggal Keluar"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Perkiraan Tanggal Keluar')">{{
                                                errors.first('Perkiraan Tanggal Keluar') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>

                        </b-card>
                    </div>
                    <!-- Data Pengangkut -->
                    <div class="col-md-6">
                        <b-card header="<i class='fa fa-plane'></i> Data Pengangkut">
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nama Sarana Pengangkut">
                                        <!-- <input v-model="headerTransit.namaSarkut" type="text" class="form-control" name="Nama Sarana Pengangkut" v-validate="'required'"> -->
                                        <model-list-select class="form-control" :list="refSarkut" option-value="nama_sarkut" option-text="nama_sarkut" v-model="headerTransit.namaSarkut" placeholder="-- Pilih Nama Sarana Pengangkut --" v-validate="'required'"></model-list-select>
                                        <small class="text-danger" v-show="errors.has('Nama Sarana Pengangkut')">{{
                                                errors.first('Nama Sarana Pengangkut') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Nomor Sarana Pengangkut">

                                        <input v-model="headerTransit.nomorSarkut" type="text" class="form-control" name="Nomor Sarana Pengangkut" v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Nomor Sarana Pengangkut')">{{
                                                errors.first('Nomor Sarana Pengangkut') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Pelabuhan Masuk">
                                        <select v-model="headerTransit.pelMasuk" name="Pelabuhan Masuk" id="" class="form-control" v-validate="'required'">
                                            <option value></option>
                                            <option value="Batu Ampar">Batu Ampar</option>
                                            <option value="Warehouse Hang Nadim">Warehouse Hang Nadim</option>
                                            <option value="Terminal Hang Nadim">Terminal Hang Nadim</option>
                                            <option value="Telaga Punggur">Telaga Punggur</option>
                                            <option value="Roro Punggur">Roro Punggur</option>
                                            <option value="Domestik Sekupang">Domestik Sekupang</option>
                                            <option value="Harbour Bay">Harbour Bay</option>
                                            <option value="Nongsa Pura">Nongsa Pura</option>
                                            <option value="Batam Center">Batam Center</option>
                                        </select>
                                        <small class="text-danger" v-show="errors.has('Pelabuhan Masuk')">{{
                                                errors.first('Pelabuhan Masuk') }}</small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Pelabuhan Keluar">
                                        <select v-model="headerTransit.pelKeluar" name="Pelabuhan Keluar" id="" class="form-control" v-validate="'required'">
                                            <option value></option>
                                            <option value="Batu Ampar">Batu Ampar</option>
                                            <option value="Warehouse Hang Nadim">Warehouse Hang Nadim</option>
                                            <option value="Terminal Hang Nadim">Terminal Hang Nadim</option>
                                            <option value="Telaga Punggur">Telaga Punggur</option>
                                            <option value="Roro Punggur">Roro Punggur</option>
                                            <option value="Domestik Sekupang">Domestik Sekupang</option>
                                            <option value="Harbour Bay">Harbour Bay</option>
                                            <option value="Nongsa Pura">Nongsa Pura</option>
                                            <option value="Batam Center">Batam Center</option>
                                        </select>
                                        <small class="text-danger" v-show="errors.has('Pelabuhan Keluar')">{{
                                                errors.first('Pelabuhan Keluar') }}"></small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-fieldset label="Tanggal Kedatangan">
                                        <input v-model="headerTransit.tanggalDatang" type="date" class="form-control" name="Tanggal Kedatangan"
                                            v-validate="'required'">
                                        <small class="text-danger" v-show="errors.has('Tanggal Kedatangan')">{{
                                                errors.first('Tanggal Kedatangan') }}"></small>
                                    </b-form-fieldset>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
                <!-- Dokumen Pendukung -->
                <div class="row">
                    <div class="col-md-12">
                        <b-card header="<i class='fa fa-file-o'></i> Data Dokumen Pendukung">
                            <div class="row">
                                <div class="col-md-10">
                                    <p><i class="fa fa-th-list"></i>List Dokumen Pendukung</p>
                                </div>
                                <div class="col-md-2">
                                    <div class="btn-group pull-right">
                                        <button @click="deleteAllDokumen" class="btn btn-danger"><i class="fa fa-trash-o"></i> Delete All</button>
                                        <button v-b-toggle.collapse-add-dokumen class="btn btn-primary"><i
                                                class="fa fa-plus"></i> Add</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4 mx-2">
                                <table class="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="1%">No</th>
                                            <th width="25%">Jenis Dokumen</th>
                                            <th width="40%">Nomor Dokumen</th>
                                            <th width="25%">Tanggal Dokumen</th>
                                            <th width="">Aksi/Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, index) in headerTransit.tableDokung" :key="index">
                                            <td>{{index + 1}}</td>
                                            <td>{{data.jenisDokumen}}</td>
                                            <td>{{data.nomorDokumen}}</td>
                                            <td>{{data.tanggalDokumen}}</td>
                                            <td>
                                                <button @click="deleteDokung(index)" class="btn btn-danger" title="delete"><i
                                                        class="fa fa-trash-o"></i></button>
                                                <button @click="editDokung(index)" class="btn btn-secondary" title="edit"><i
                                                        class="fa fa-edit"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- collapse input dokumen pendukung -->
                            <b-collapse id="collapse-add-dokumen" class="mx-2">
                                <b-card header="<i class='fa fa-edit'></i> Tambah Dokumen Pendukung">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Jenis Dokumen Pendukung">
                                                <select v-model="detailDokung.jenisDokumen" name="Jenis Dokumen Pendukung" id="" class="form-control">
                                                    <option value=""></option>
                                                    <option value="Invoice">Invoice</option>
                                                    <option value="Packing List">Packing List</option>
                                                    <option value="Purchase Order">Purchase Order</option>
                                                    <option value="Kontrak">Kontrak</option>
                                                    <option value="Flyer">Flyer</option>
                                                    <option value="Lainnya">Lainnya</option>
                                                </select>
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Nomor Dokumen">
                                                <input v-model="detailDokung.nomorDokumen" type="text" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Tanggal Dokumen">
                                                <input v-model="detailDokung.tanggalDokumen" type="date" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div class="pull-right">
                                                <button @click="submitDokung" class="btn btn-primary" v-b-toggle.collapse-add-dokumen><i
                                                        class="fa fa-save"></i> Save</button>
                                                <button class="btn btn-danger" v-b-toggle.collapse-add-dokumen><i
                                                        class="fa fa-times"></i> Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                            </b-collapse>
                            <!-- collapse edit dokumen pendukung -->
                            <b-collapse v-for="(data, index) in headerTransit.tableDokung" :key="index" :id="`collapse-edit-dokumen ${index}`" :ref="`collapse-edit-dokumen ${index}`" class="mx-2">
                                <b-card :header="`<i class='fa fa-edit'></i> Edit Dokumen Pendukung ${index+1}`">
                                    <div class="row">
                                    <div class="col-md-4">
                                        <b-form-fieldset label="Jenis Dokumen Pendukung">
                                        <select v-model="editedDokung.jenisDokumen" name="Jenis Dokumen Pendukung" class="form-control">        
                                            <option value=""></option>
                                            <option value="Invoice">Invoice</option>
                                            <option value="Packing List">Packing List</option>
                                            <option value="Purchase Order">Purchase Order</option>
                                            <option value="Kontrak">Kontrak</option>
                                            <option value="Flyer">Flyer</option>
                                            <option value="Lainnya">Lainnya</option>
                                        </select>
                                        </b-form-fieldset>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-fieldset label="Nomor Dokumen">
                                        <input v-model="editedDokung.nomorDokumen" type="text" class="form-control">
                                        </b-form-fieldset>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-fieldset label="Tanggal Dokumen">
                                        <input v-model="editedDokung.tanggalDokumen" type="date" class="form-control">
                                        </b-form-fieldset>
                                    </div>
                                    </div>
                                    <div class="row mt-2">
                                    <div class="col-md-12">
                                        <div class="pull-right">
                                        <button @click="saveEditDokung(index)" class="btn btn-primary" v-b-toggle="`collapse-edit-dokumen ${index}`"><i class="fa fa-save"></i> Save</button>
                                        <button v-b-toggle="`collapse-edit-dokumen ${index}`" class="btn btn-danger"><i class="fa fa-times"></i> Cancel</button>
                                        </div>
                                    </div>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
                <!-- Data Barang -->
                <div class="row">
                    <div class="col-md-12">
                        <b-card header="<i class='fa fa-archive'></i> Data Barang">
                            <div class="row">
                                <div class="col-md-10">
                                    <p><i class="fa fa-th-list"></i>List Data Barang</p>
                                </div>
                                <div class="col-md-2">
                                    <div class="btn-group pull-right">
                                        <button @click="deleteAllGood" class="btn btn-danger"><i class="fa fa-trash-o"></i> Delete All</button>
                                        <button v-b-toggle.collapse-add-barang class="btn btn-primary"><i
                                                class="fa fa-plus"></i> Add</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3 mx-2">
                                <table class="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="1%" scope="col">No</th>
                                            <th width="" scope="col">Uraian Barang / <i>Description of Goods</i></th>
                                            <th width="15%" scope="col">Type/Merk / <i>Type/Brand</i></th>
                                            <th width="15%" scope="col">Harga / <i>Price</i></th>
                                            <th width="15%" scope="col">No. Seri / <i>Serial Number</i></th>
                                            <th width="10%" scope="col">Jumlah / <i>Amount</i></th>
                                            <th width="10%" scope="col">Keterangan / <i>information</i></th>
                                            <th width="9%" scope="col">Aksi / <i>Action</i></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data,index) in headerTransit.tableDetail" :key="index">
                                            <td> {{ index + 1 }} </td>
                                            <td> {{ data.uraianBarang }} </td>
                                            <td> {{ data.typeMerk }} </td>
                                            <td> {{ data.harga }} </td>
                                            <td> {{ data.noSeri }} </td>
                                            <td> {{ data.jumlahBarang }} {{ data.satuanBarang }} </td>
                                            <td> {{ data.keterangan }} </td>
                                            <td>
                                                <button @click="deleteGood(index)" class="btn btn-danger" title="delete"><i
                                                        class="fa fa-trash-o"></i></button>
                                                <button v-b-toggle="`collapse-edit-barang ${index}`" class="btn btn-secondary" title="edit"><i
                                                        class="fa fa-edit"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- collapse input barang -->
                            <b-collapse id="collapse-add-barang" class="mx-2">
                                <b-card header="<i class='fa fa-edit'></i> Tambah Data Barang">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Uraian Barang">
                                                <input v-model="detailTransit.uraianBarang" type="text" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Type/Merk">
                                                <input v-model="detailTransit.typeMerk" type="text" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Harga">
                                                <input v-model="detailTransit.harga" type="number" class="form-control" min="0">
                                            </b-form-fieldset>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Nomor Seri">
                                                <input v-model="detailTransit.noSeri" type="text" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Jumlah Barang">
                                                <input v-model="detailTransit.jumlahBarang" type="number" class="form-control" min="0">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Satuan Barang">
                                                <!-- <input v-model="detailTransit.satuanBarang" type="text" class="form-control"> -->
                                                 <model-list-select class="form-control" :list="formattedJenisSatuan" option-value="value" option-text="text" v-model="detailTransit.satuanBarang"></model-list-select>
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Keterangan">
                                                <input v-model="detailTransit.keterangan" type="text" class="form-control">
                                            </b-form-fieldset>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div class="pull-right">
                                                <button @click="submitGoods" class="btn btn-primary" v-b-toggle.collapse-add-barang><i
                                                        class="fa fa-save"></i> Save</button>
                                                <button class="btn btn-danger" v-b-toggle.collapse-add-barang><i
                                                        class="fa fa-times"></i> Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                            </b-collapse>
                            <!-- collapse edit barang -->
                            <b-collapse v-for="(data,index) in headerTransit.tableDetail" :key="index" :id="`collapse-edit-barang ${index}`" class="mt-2">
                                <b-card :header="`<i class='fa fa-edit'></i> Edit Barang ${index+1} `">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Uraian Barang">
                                                <input v-model="detailTransit.uraianBarang" :placeholder="data.uraianBarang" class="detail form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Type / Merk">
                                                <input v-model="detailTransit.typeMerk" :placeholder="data.typeMerk" class="detail form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-fieldset label="Harga">
                                                <input v-model="detailTransit.harga" :placeholder="data.harga" class="detail form-control" min="0" type="number">
                                            </b-form-fieldset>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Nomor Seri">
                                                <input v-model="detailTransit.noSeri" :placeholder="data.noSeri" class="detail form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Jumlah Barang">
                                                <input v-model="detailTransit.jumlahBarang" :placeholder="data.jumlahBarang" class="detail form-control">
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Satuan Barang">
                                                <!-- <input v-model="detailTransit.satuanBarang" :placeholder="data.satuanBarang" class="detail form-control" type="text"> -->
                                                <model-list-select class="form-control" :list="formattedJenisSatuan" option-value="value" option-text="text" v-model="detailTransit.satuanBarang" :placeholder="data.satuanBarang"></model-list-select>
                                            </b-form-fieldset>
                                        </div>
                                        <div class="col-md-3">
                                            <b-form-fieldset label="Keterangan">
                                                <input v-model="detailTransit.keterangan" :placeholder="data.keterangan" class="detail form-control" type="text">
                                            </b-form-fieldset>
                                        </div>
                                    </div>
                                    <div class="mt-3 pull-right">
                                        <button @click="saveEditBarang(index)" v-b-toggle="`collapse-edit-barang ${index}`" class="btn btn-primary"><i class="fa fa-save"></i> Save</button>
                                        <button v-b-toggle="`collapse-edit-barang ${index}`" class="btn btn-danger"><i class="fa fa-times"></i> Cancel</button>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
                <div class="row justify-content-between">
                    <div class="col-md-6">
                        <router-link :to="'/login'">
                            <button class="btn btn-default btn-lg"><i class="fa fa-times"></i> Cancel</button>
                        </router-link>
                    </div>
                    <div class="col-md-6">
                        <button @click="cekSubmitAll" class="btn btn-primary btn-lg pull-right"><i class="fa fa-paper-plane"></i>
                            Send</button>
                    </div>
                </div>
        </b-card>
        <b-modal hide-footer title="Persetujuan" v-model="modalPersetujuan" @ok="modalPersetujuan = false">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-12">
                            Saya menyatakan bahwa data yang disampaikan adalah benar
                            dan saya bertanggung jawab atas kebenaran data/dokumen yang disampaikan
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <vue-recaptcha
                              :sitekey=sitekey
                              @verify="onCaptchaVerified"
                              @expired="onCaptchaExpired"
                            ></vue-recaptcha>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <button class="btn btn-success btn-block btn-lg" @click="submitAll()">Kirim</button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
import swal from 'sweetalert'
import {ModelListSelect} from 'vue-search-select'
import Loading from 'vue-loading-overlay'
export default {
  components: {
    ModelListSelect,
    VueRecaptcha,
    Loading
  },
  data () {
    return {
      headerTransit: {
        namaPemberitahu: '',
        jenisIdPemberitahu: '',
        idPemberitahu: '',
        alamatPemberitahu: '',
        pekerjaanPemberitahu: '',
        noTelpPemberitahu: '',
        namaSponsor: '',
        jenisIdSponsor: '',
        idSponsor: '',
        alamatSponsor: '',
        pekerjaanSponsor: '',
        noTelpSponsor: '',
        jenisPemasukan: '',
        tujuanPemasukan: '',
        tujuanPemasukanLainnya: '',
        lokasiPenggunaan: '',
        asalBarang: '',
        perkiraanTanggalKeluar: '',
        namaSarkut: '',
        nomorSarkut: '',
        pelMasuk: '',
        pelKeluar: '',
        tanggalDatang: '',
        tableDetail: [],
        tableDokung: [],
        recaptchaToken: '',
        jenisTransit: 'Barang Penumpang'
      },
      detailTransit: {
        uraianBarang: '',
        typeMerk: '',
        noSeri: '',
        jumlahBarang: '',
        satuanBarang: '',
        harga: '',
        keterangan: ''
      },
      detailDokung: {
        jenisDokumen: '',
        nomorDokumen: '',
        tanggalDokumen: ''
      },
      refSarkut: [],
      tambahRefSarkut: {
        nama: ''
      },
      modalRefSarkut: false,
      refKota: [],
      editedIndex: -1,
      editedDokung: {
        jenisDokumen: '',
        nomorDokumen: '',
        tanggalDokumen: ''
      },
      modalPersetujuan: false,
      refSatuan: [],
      isLoading: false,
      sitekey: '6LfnWwIqAAAAANCiVDEj6w0E6IzsYRw7_6Kg3IZd'
    }
  },
  methods: {
    submitAll () {
      this.isLoading = true
      if (this.headerTransit.recaptchaToken) {
        this.$http.post('storeTransit', this.headerTransit).then(response => {
          this.isLoading = false
          this.$router.push('/resulttransit/' + response.data.kd_regis)
        })
      }
    },
    submitDokung () {
      this.headerTransit.tableDokung.push({
        jenisDokumen: this.detailDokung.jenisDokumen,
        nomorDokumen: this.detailDokung.nomorDokumen,
        tanggalDokumen: this.detailDokung.tanggalDokumen
      })
      this.cleanFormDokung()
    },
    cleanFormDokung () {
      this.detailDokung.jenisDokumen = ''
      this.detailDokung.nomorDokumen = ''
      this.detailDokung.tanggalDokumen = ''
    },
    loadNamaSarkut () {
      this.$http.get('transit/load/namaSarkut').then(response => {
        this.refSarkut = response.data
      })
    },
    editDokung (index) {
      this.$refs[`collapse-edit-dokumen ${index}`][0].toggle()

      this.editedDokung.jenisDokumen = this.headerTransit.tableDokung[index].jenisDokumen
      this.editedDokung.nomorDokumen = this.headerTransit.tableDokung[index].nomorDokumen
      this.editedDokung.tanggalDokumen = this.headerTransit.tableDokung[index].tanggalDokumen
    },
    saveEditDokung (index) {
      if (this.editedDokung.jenisDokumen !== '') {
        this.headerTransit.tableDokung[index].jenisDokumen = this.editedDokung.jenisDokumen
      }

      if (this.editedDokung.nomorDokumen !== '') {
        this.headerTransit.tableDokung[index].nomorDokumen = this.editedDokung.nomorDokumen
      }

      if (this.editedDokung.tanggalDokumen !== '') {
        this.headerTransit.tableDokung[index].tanggalDokumen = this.editedDokung.tanggalDokumen
      }
    },
    deleteDokung (index) {
      this.headerTransit.tableDokung.splice(index, 1)
    },
    deleteAllDokumen (index) {
      this.headerTransit.tableDokung.splice(index)
    },
    submitGoods () {
      this.headerTransit.tableDetail.push({
        uraianBarang: this.detailTransit.uraianBarang,
        typeMerk: this.detailTransit.typeMerk,
        noSeri: this.detailTransit.noSeri,
        jumlahBarang: this.detailTransit.jumlahBarang,
        satuanBarang: this.detailTransit.satuanBarang,
        harga: this.detailTransit.harga,
        keterangan: this.detailTransit.keterangan
      })
      this.clearFieldGoods()
    },
    clearFieldGoods () {
      this.detailTransit.uraianBarang = ''
      this.detailTransit.typeMerk = ''
      this.detailTransit.noSeri = ''
      this.detailTransit.jumlahBarang = ''
      this.detailTransit.satuanBarang = ''
      this.detailTransit.harga = ''
      this.detailTransit.keterangan = ''
    },
    deleteGood (index) {
      this.headerTransit.tableDetail.splice(index, 1)
    },
    deleteAllGood (index) {
      this.headerTransit.tableDetail.splice(index)
    },
    saveEditBarang (index) {
      if (this.detailTransit.uraianBarang !== '') {
        this.headerTransit.tableDetail[index].uraianBarang = this.detailTransit.uraianBarang
      }
      if (this.detailTransit.typeMerk !== '') {
        this.headerTransit.tableDetail[index].typeMerk = this.detailTransit.typeMerk
      }
      if (this.detailTransit.noSeri !== '') {
        this.headerTransit.tableDetail[index].noSeri = this.detailTransit.noSeri
      }
      if (this.detailTransit.jumlahBarang !== '') {
        this.headerTransit.tableDetail[index].jumlahBarang = this.detailTransit.jumlahBarang
      }
      if (this.detailTransit.satuanBarang !== '') {
        this.headerTransit.tableDetail[index].satuanBarang = this.detailTransit.satuanBarang
      }
      if (this.detailTransit.harga !== '') {
        this.headerTransit.tableDetail[index].harga = this.detailTransit.harga
      }
      if (this.detailTransit.keterangan !== '') {
        this.headerTransit.tableDetail[index].keterangan = this.detailTransit.keterangan
      }
    },
    cekSubmitAll () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.headerTransit.tableDetail.length > 0) {
            this.modalPersetujuan = true
          } else {
            swal('error', 'Barang Masih Kosong', 'error')
          }
        }
      })
    },
    onCaptchaVerified (recaptchaToken) {
      this.headerTransit.recaptchaToken = recaptchaToken
    },
    onCaptchaExpired () {
      this.headerTransit.recaptchaToken = ''
    },
    loadRefSatuan () {
      this.$http.get('transit/ref/jnsatuan').then((response) => {
        this.refSatuan = response.data
      })
    }
  },
  created () {
    this.loadNamaSarkut()
    this.loadRefSatuan()
  },
  computed: {
    formattedJenisSatuan () {
      return this.refSatuan.map(item => {
        return {
          value: item.UR_SAT,
          text: `${item.JNS_SAT} - ${item.UR_SAT}`
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/transit/FormTransitNew.vue?77a8a0fa